import React, { useEffect } from "react";
import { LogOut, ScanLine } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BrandLogo } from "../shared/BrandLogo";

export function PosShell({ children }) {
  const { user, logout } = useAuth();

  useEffect(() => {
    const link = document.getElementById("app-manifest");
    if (link) link.setAttribute("href", "/pos-manifest.json");
    return () => {
      if (link) link.setAttribute("href", "/manifest.json");
    };
  }, []);

  return (
    <div className="min-h-screen bg-primary" data-testid="pos-shell">
      <header className="flex items-center justify-between border-b border-white/10 bg-primary px-4 py-3.5">
        <div className="flex items-center gap-2">
          <ScanLine size={20} strokeWidth={1.5} className="text-accent" />
          <div>
            <BrandLogo className="h-5" />
            <p className="mt-1 text-[11px] text-white/60">{user?.username ? `Staff · ${user.username}` : "Counter App"}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={logout}
          className="flex items-center gap-1.5 rounded-md border border-white/15 px-3 py-1.5 text-xs font-medium text-white/80 transition-colors hover:bg-white/10 hover:text-white"
          data-testid="pos-logout-button"
        >
          <LogOut size={14} strokeWidth={1.5} /> Logout
        </button>
      </header>
      <main className="mx-auto max-w-lg px-4 py-5" style={{ minHeight: "calc(100vh - 60px)" }} data-testid="pos-main-content">
        {children}
      </main>
    </div>
  );
}
